import { create } from 'zustand';

const useUiStore = create((set) => ({
  sidebarOpen: true,
  globalLoading: false,
  pageTitle: '',

  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setGlobalLoading: (globalLoading) => set({ globalLoading }),
  setPageTitle: (pageTitle) => set({ pageTitle }),
  resetUiState: () =>
    set({
      sidebarOpen: true,
      globalLoading: false,
      pageTitle: '',
    }),
}));

export default useUiStore;
